<div class="flex-column gap">
    <div class="input-grid-gaps grid-2col">
        <div class="flex flex-1 detailList">
            <app-folder-e-prescriptions-list class="w-full" [selectedId]="prescriptionId()"
                (selectedChanged)="selection($event)"></app-folder-e-prescriptions-list>
        </div>
        <div class="flex flex-1 detailForm">
            <app-folder-e-prescription-form class="w-full"
                [prescription]="selectedPrescription()"
                [preselectMedication]="preselectMedication()"
            ></app-folder-e-prescription-form>
        </div>
    </div>

    <div class="flex align-items-center justify-content-between">
        <app-button icon="pi-list" label="ePrescriptions.buttons.clientMedicationEntries"
            (clickEvent)="openMedicationEntriesModal($event)"></app-button>

        <div class="flex gap">
            <app-return-button></app-return-button>
            <app-button
                [disabled]="!selectedPrescription()"
                (clickEvent)="upsertMedication()"
                icon="pi-times" label="ePrescriptions.buttons.setToActualMedication"
                severity="warn"></app-button>
        </div>
    </div>
</div>
